export default {
  tableFields: [
    {
      name: '__component:badge-column',
      title: '',
      dataClass: 'text-center'
    },
    {
      name: 'name',
      title: 'Sala',
      sortField: 'name'
    },
    {
      name: 'salary',
      title: 'Turma'
    },
    {
      name: 'nickname',
      title: 'Materia',
      sortField: 'nickname'
    },
    {
      name: 'group_id',
      title: '#Aula',
    }
  ],
  sortFunctions: {
    'name': function (item1, item2) {
      return item1 >= item2 ? 1 : -1
    }
  }
}
